<template>
<div>
  <router-view></router-view>
</div>
</template>
<script>
import api from "@/services/api";
import store from "@/store"
export default {

   beforeRouteEnter (to, from, next) {
    if (
      store.getters['auth/isLoki']
    ) {
      next()
    } else next("/odin")
  },
   async beforeMount() {
     try {
      const response = await api.getMenu("loki");
      this.$store.commit("utils/isMenu", response.data);
    } catch (error) {
      this.errorCatch(error);
    } 
  },
};
</script>